/*eslint-disable*/
/* eslint-disable react/prop-types */
/* eslint-disable no-use-before-define */
/* eslint-disable quotes */
import React, { useState, useEffect, useContext } from "react";
import MaterialTable from "material-table";
import { useSelector, useDispatch } from "react-redux";
import { FirebaseContext } from "common";
import GridContainer from "components/Grid/GridContainer.js";
import ForwardIcon from "@material-ui/icons/Forward";
import EditIcon from "@material-ui/icons/Edit";

import PublishIcon from "@material-ui/icons/Publish";

import { AddBoxRounded, ArrowUpwardRounded } from "@material-ui/icons";
import GridItem from "components/Grid/GridItem.js";
import { features, language, offices, regions } from "config";
import { Grid, Typography } from "@material-ui/core";

import moment from "moment";
import {
  Row,
  Col,
  CardImg,
  Label,
  CardBody,
  Card,
  CardHeader,
  CardTitle,
  FormGroup,
  Input,
  FormText,
  Button,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
} from "reactstrap";

import FlatList from "flatlist-react";
import { makeStyles } from "@material-ui/core";
import { Modal, ModalBody, ModalHeader, ModalFooter } from "reactstrap";
import { useNavigate, useLocation } from "react-router-dom";
import GoogleMapsAutoComplete from "components/GoogleMapsAutoComplete";

const useStyles = makeStyles((theme) => ({
  card: {
    display: "flex",
  },
  //The negitive value on margin top is to help align the text with the radio button
  radioButton: {
    marginLeft: 25,
    borderColor: "#009ad8",
    borderWidth: 2,
    height: 25,
    width: 25,
    marginTop: -4,
    marginRight: 5,
  },
  details: {
    display: "flex",
    flexDirection: "column",
  },
  input: {
    borderWidth: 2,
    borderColor: "#f00000",
    height: 40,
    backgroundColor: "white",
    fontSize: 16,
    paddingHorizontal: 10,
    paddingVertical: 8,
    borderRadius: 8,
    color: "grey",
    paddingRight: 30,
  },

  checkinput: {
    marginLeft: 25,
    borderColor: "#009ad8",
    borderWidth: 2,
    borderRadius: 8,
    height: 25,
    width: 25,
    marginTop: -4,
    marginRight: 5,
  },

  descriptioninput: {
    borderWidth: 2,
    borderColor: "#f00000",
    height: 250,
    backgroundColor: "white",
    fontSize: 16,
    paddingHorizontal: 10,
    paddingVertical: 8,
    borderRadius: 8,
    color: "grey",
    paddingRight: 30,
  },

  content: {
    flex: "1 0 auto",
  },
  cover: {
    width: 151,
  },
}));

export default function CreateListingsDashboardModal() {
  const { api } = useContext(FirebaseContext);
  const styles = useStyles();
  const { CreateListing, clearListingErrors, UpdateListing, fetchAllListings } =
    api;

  //useStates
  const [isOpen, setIsOpen] = useState(false);
  const [brokerList, setBrokerList] = useState([]);
  const [image, setImage] = useState([]);
  const [video, setVideo] = useState();

  const re =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  const phoneRegex =
    /^(\+\d{1,2}\s?)?1?\-?\.?\s?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;

  const dispatch = useDispatch();

  //useSelectors
  const brokers = useSelector((state) => state.brokers.users);
  const auth = useSelector((state) => state.auth);
  const listingManagementReducer = useSelector((state) => state.ListingData);

  const toggleTwo = () => setIsOpen(!isOpen);

  //!!Extremly important useEffect
  //?? Used to tell if the Listing was Created and handle errors from reducers and actions
  //?? Last Updated 2024/03/05
  useEffect(() => {
    if (
      listingManagementReducer.completed &&
      listingManagementReducer.success
    ) {
      alert("Listing Created");
      toggleTwo();
      dispatch(clearListingErrors());
    }

    if (
      !listingManagementReducer.success &&
      listingManagementReducer.error.flag
    ) {
      console.log(
        "listingManagementReducer.error",
        listingManagementReducer.error.msg
      );
      alert(
        `\tCreate Listing Failed \n ${listingManagementReducer.error.msg} `
      );
      dispatch(clearListingErrors());
    }
  }, [listingManagementReducer]);

  const [state, setstate] = useState({
    status: "Active",
    municipalValue: 0,
    valuationPrice: 0,
    gla: 0,
    address: "",
    standSize: "",
    type: "",
    erf: "",
    deposit: "",
    location: "",
    // title: "",
    Street: "",
    typeOfProperty: false,
    typeOfMandate: "",
    typeOfTitle: "",
    unit: "",
    additionalNotes: "",
    price: "",
    saleboth: "",
    officeSize: "None",
    officePrice: 0,
    retailSize: "None",
    retailPrice: 0,
    factorySize: "None",
    factoryPrice: 0,
    yardSize: "None",
    yardPrice: 0,
    landSize: "None",
    floorSize: 0,
    industrialCommercial: "",
    buildingHieght: 0,
    grossmonthlyRental: "None",
    ownerBroker: "",
    office: auth.info.profile.adminHomeOffice,
    seller: {
      entityName: "",
      registrationNumber: "",
      postalAddress: "",
      ownername: "",
      company: "",
      cellTel: "",
      homeTel: "",
      workTel: "",
      investor: false,
      email: "",
      vatVendor: false,
      vatNumber: "",
    },
  });


  const isYouTubeVideo = (item) => {
    const youtubeRegex = /^(https?:\/\/)?(www\.)?(youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/)([\w\-]+)|youtu\.be\/([\w\-]+))(?:\S+)?$/;;
    return youtubeRegex.test(item);
  };
  useEffect(() => {
    let arr = [];
    if (brokers) {
      for (let index = 0; index < brokers.length; index++) {
        const element = brokers[index];

        // Populate the list with all brokers, remove brokerHomeOffice filter
        if (element.brokerHomeOffice === auth?.info?.profile?.adminHomeOffice) {
          arr.push({
            value: element.id, // The broker ID (or name if preferred)
            label: `${element.firstName} ${element.lastName}`, // Broker name
          });
        }
      }
      setBrokerList(arr.sort((a, b) => a.label.localeCompare(b.label)));
    }
  }, [brokers]);

  const renderPropertyInfoCard = () => {
    return (
      <Card
        style={{
          backgroundColor: "#399ddb",
          width: "100%",
          height: "97.4%",
        }}
      >
        <CardHeader>
          <CardTitle tag="h4" style={{ color: "white" }}>
            Property Information
          </CardTitle>
        </CardHeader>
        <CardBody>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <GridContainer spacing={1}>
              <GridItem xs={12}>
                <FormText color="white" tag="span">
                  Broker Owner :
                </FormText>

                {brokerList && brokerList.length > 0 ? (
                  <Input
                    fullWidth
                    type="select"
                    style={{
                      borderWidth: 2,
                      borderColor: "#f00000",
                      backgroundColor: "white",
                      color: "grey",
                    }}
                    value={state.ownerBroker}
                    onChange={(e) => {
                      saveData("ownerBroker", e.target.value);
                    }}
                  >
                    <option value="" disabled>
                      Select a Broker
                    </option>
                    {brokerList.map((broker) => (
                      <option key={broker.value} value={broker.value}>
                        {broker.label}
                      </option>
                    ))}
                  </Input>
                ) : (
                  <FormText color="grey">No brokers available</FormText> // Fallback if no brokers
                )}
              </GridItem>

              <GridItem xs={12}>
                <FormText color="white" tag="span">
                  Erf number:
                </FormText>
                <Input
                  onChange={(value) => {
                    value.preventDefault();
                    saveData("erf", value.target.value);
                  }}
                  fullWidth
                  type="number"
                  className={styles.input}
                  placeholder="erf number"
                />
              </GridItem>

              <GridItem xs={12}>
                <FormText color="white" tag="span">
                  Type of Mandate:
                </FormText>
                <Input
                  onChange={(value) => {
                    value.preventDefault();
                    saveData("typeOfMandate", value.target.value);
                  }}
                  fullWidth
                  type="select"
                  style={{
                    borderWidth: 2,
                    borderColor: "#f00000",
                    backgroundColor: "white",
                    color: "grey",
                  }}
                  placeholder="Select an item..."
                >
                  <option value="">Select a Mandate Type</option>
                  <option>Open</option>
                  <option>Sole</option>
                  <option>None</option>
                  <option>Company Listing</option>
                  <option>Shared</option>
                  <option>Referral</option>
                </Input>
              </GridItem>

              <GridItem xs={12}>
                <FormText color="white" tag="span">
                  Industrial/Commercial:
                </FormText>
                <Input
                  fullWidth
                  type="select"
                  style={{
                    borderWidth: 2,
                    borderColor: "#f00000",
                    backgroundColor: "white",
                    color: "grey",
                  }}
                  placeholder="Select an item..."
                  onChange={(value) => {
                    saveData("industrialCommercial", value.target.value);
                  }}
                  value={state.industrialCommercial}
                >
                  <option value="" disabled>
                    Industrial/Commercial
                  </option>
                  <option>Commercial</option>
                  <option>Industrial</option>
                </Input>
              </GridItem>

              <GridItem xs={12}>
                <FormText color="white" tag="span">
                  Type of property:
                </FormText>
                <Input
                  onChange={(value) => {
                    value.preventDefault();
                    saveData("typeOfProperty", value.target.value);
                  }}
                  fullWidth
                  type="select"
                  style={{
                    borderWidth: 2,
                    borderColor: "#f00000",
                    backgroundColor: "white",
                    color: "grey",
                  }}
                  placeholder="Select an item..."
                >
                  <option value="">Select a Property Type</option>
                  <option>Warehouse</option>
                  <option>Workshop</option>
                  <option>Mini Factory</option>
                  <option>Factory</option>
                  <option>Storage Unit</option>
                  <option>Investment</option>
                  <option>Industrial Yard</option>
                  <option>Vacant Land</option>
                  <option>Showroom</option>
                  <option>Retail</option>
                  <option>Office</option>
                  <option>Restaurant</option>
                  <option>Hotel</option>
                  <option>Guesthouse</option>
                  <option>Medical Suite</option>
                  <option>Business Centre</option>
                  <option>Service Station</option>
                  <option>Small Holding</option>
                  <option>Full Floor</option>
                  <option>Business</option>
                  <option>Building</option>
                </Input>
              </GridItem>

              <GridItem xs={12}>
                <FormText color="white" tag="span">
                  Address:
                </FormText>
                <Input
                  onChange={(value) => {
                    value.preventDefault();
                    saveAddressData("description", value.target.value);
                  }}
                  fullWidth
                  type="text"
                  className={styles.input}
                  placeholder="Address"
                />
              </GridItem>

              <GridItem xs={12}>
                <FormText color="white" tag="span">
                  Street Number:
                </FormText>
                <Input
                  onChange={(value) => {
                    value.preventDefault();
                    saveAddressData("streetNumber", value.target.value);
                  }}
                  fullWidth
                  type="text"
                  className={styles.input}
                  placeholder="street number"
                />
              </GridItem>

              <GridItem xs={12}>
                <FormText color="white" tag="span">
                  Street Name:
                </FormText>
                <Input
                  onChange={(value) => {
                    value.preventDefault();
                    saveAddressData("streetName", value.target.value);
                  }}
                  fullWidth
                  type="text"
                  className={styles.input}
                  placeholder="street name"
                />
              </GridItem>

              <GridItem xs={12}>
                <FormText color="white" tag="span">
                  Unit Number:
                </FormText>
                <Input
                  onChange={(value) => {
                    value.preventDefault();
                    saveAddressData("unitNumber", value.target.value);
                  }}
                  fullWidth
                  type="text"
                  className={styles.input}
                  placeholder="unit number"
                />
              </GridItem>

              <GridItem xs={12}>
                <FormText color="white" tag="span">
                  Complex Name:
                </FormText>
                <Input
                  onChange={(value) => {
                    value.preventDefault();
                    saveAddressData("complexName", value.target.value);
                  }}
                  fullWidth
                  type="text"
                  className={styles.input}
                  placeholder="complex name"
                />
              </GridItem>

              <GridItem xs={12}>
                <FormText color="white" tag="span">
                  Floor Number:
                </FormText>
                <Input
                  onChange={(value) => {
                    value.preventDefault();
                    saveAddressData("floorNumber", value.target.value);
                  }}
                  fullWidth
                  type="text"
                  className={styles.input}
                  placeholder="floor number"
                />
              </GridItem>

              <GridItem xs={12}>
                <FormText color="white" tag="span">
                  Building Name:
                </FormText>
                <Input
                  onChange={(value) => {
                    value.preventDefault();
                    saveAddressData("buildingName", value.target.value);
                  }}
                  fullWidth
                  type="text"
                  className={styles.input}
                  placeholder="building name"
                />
              </GridItem>

              <GridItem xs={12}>
                <FormGroup>
                  <FormText color="white" tag="span">
                    Type:
                  </FormText>
                  <Label
                    check
                    className={styles.radioText}
                    style={{ color: "white", marginTop: 40 }}
                  >
                    <Input
                      type="radio"
                      name="radio1"
                      className={styles.radioButton}
                      onChange={() => saveData("type", "sale")}
                    />
                    Sale
                  </Label>
                  <Label
                    check
                    className={styles.radioText}
                    style={{ color: "white" }}
                  >
                    <Input
                      type="radio"
                      name="radio1"
                      className={styles.radioButton}
                      onChange={() => saveData("type", "tolet")}
                    />
                    To Let
                  </Label>
                  <Label
                    check
                    className={styles.radioText}
                    style={{ color: "white", alignItems: "center" }}
                  >
                    <Input
                      type="radio"
                      name="radio1"
                      className={styles.radioButton}
                      onChange={() => saveData("type", "both")}
                    />
                    Both
                  </Label>
                </FormGroup>
              </GridItem>

              {state.type && state.type !== "both" ? (
                <>
                  <GridItem xs={6}>
                    <FormText color="white" tag="span">
                      {state.type === "sale" ? "Sale Price" : "GROSS RENTAL"}
                    </FormText>
                    <Input
                      fullWidth
                      onChange={(value) => {
                        value.preventDefault();
                        saveData("price", value.target.value);
                      }}
                      type="text"
                      className={styles.input}
                      placeholder={
                        state.type === "sale" ? "Sale Price" : "GROSS RENTAL"
                      }
                    />
                  </GridItem>
                  <GridItem xs={6}>
                    <FormText color="white" tag="span">
                      Deposit:
                    </FormText>
                    <Input
                      onChange={(value) => {
                        value.preventDefault();
                        saveData("deposit", value.target.value);
                      }}
                      fullWidth
                      type="text"
                      className={styles.input}
                      placeholder="Deposit Price"
                    />
                  </GridItem>
                </>
              ) : state.type ? (
                <>
                  <GridItem xs={6}>
                    <FormText color="white" tag="span">
                      Sale Price
                    </FormText>
                    <Input
                      onChange={(value) => {
                        value.preventDefault();
                        saveData("price", value.target.value);
                      }}
                      fullWidth
                      type="text"
                      className={styles.input}
                      placeholder="Sale Price"
                    />
                  </GridItem>

                  <GridItem xs={6}>
                    <FormText color="white" tag="span">
                      Deposit:
                    </FormText>
                    <Input
                      onChange={(value) => {
                        value.preventDefault();
                        saveData("deposit", value.target.value);
                      }}
                      fullWidth
                      type="text"
                      className={styles.input}
                      placeholder="Deposit Price"
                    />
                  </GridItem>

                  <GridItem xs={6}>
                    <FormText color="white" tag="span">
                      GROSS RENTAL
                    </FormText>
                    <Input
                      onChange={(value) => {
                        value.preventDefault();
                        saveData("rent", value.target.value);
                      }}
                      fullWidth
                      type="text"
                      className={styles.input}
                      placeholder="GROSS RENTAL"
                    />
                  </GridItem>
                  <GridItem xs={6}>
                    <FormText color="white" tag="span">
                      Deposit:
                    </FormText>
                    <Input
                      onChange={(value) => {
                        value.preventDefault();
                        saveData("rentdeposit", value.target.value);
                      }}
                      fullWidth
                      type="text"
                      className={styles.input}
                      placeholder="Deposit Price"
                    />
                  </GridItem>
                </>
              ) : null}

              {state.type ? (
                <>
                  <GridItem xs={12}>
                    <FormText color="white" tag="span">
                      Available from:
                    </FormText>
                    <Input
                      onChange={(value) => {
                        value.preventDefault();
                        saveData("availableFrom", value.target.value);
                      }}
                      fullWidth
                      type="date"
                      className={styles.input}
                    />
                  </GridItem>

                  <GridItem xs={12}>
                    <FormText color="white" tag="span">
                      Valuation Price:
                    </FormText>
                    <Input
                      onChange={(value) => {
                        value.preventDefault();
                        saveData("valuationPrice", value.target.value);
                      }}
                      fullWidth
                      type="number"
                      className={styles.input}
                      placeholder="Valuation Price"
                    />
                  </GridItem>

                  <GridItem xs={12}>
                    <FormText color="white" tag="span">
                      Square Meter Price:
                    </FormText>
                    <Input
                      onChange={(value) => {
                        value.preventDefault();
                        saveData("ppsm", value.target.value);
                      }}
                      fullWidth
                      type="number"
                      className={styles.input}
                      placeholder="Price Per Square Meter"
                    />
                  </GridItem>

                  <GridItem xs={12}>
                    <FormText color="white" tag="span">
                      Municipal Value:
                    </FormText>
                    <Input
                      onChange={(value) => {
                        value.preventDefault();
                        saveData("municipalValue", value.target.value);
                      }}
                      fullWidth
                      type="number"
                      className={styles.input}
                      placeholder="Municipal Value"
                    />
                  </GridItem>

                  {state.type === "tolet" || state.type === "both" ? (
                    <>
                      <GridItem xs={12}>
                        <FormText color="white" tag="span">
                          Lease Period:
                        </FormText>
                        <Input
                          fullWidth
                          onChange={(value) => {
                            value.preventDefault();
                            saveData("leaseperiod", value.target.value);
                          }}
                          type="select"
                          style={{
                            borderWidth: 2,
                            borderColor: "#f00000",
                            backgroundColor: "white",
                            color: "grey",
                          }}
                          placeholder="Select an item..."
                        >
                          <option value="">Select a Time Period</option>
                          <option>Negotiable</option>
                          <option>2 months</option>
                          <option>4 months</option>
                          <option>6 months</option>
                          <option>8 months</option>
                          <option>10 months</option>
                          <option>1 year</option>
                          <option>2 years</option>
                          <option>3 years</option>
                          <option>4 years</option>
                          <option>5 years plus</option>
                        </Input>
                      </GridItem>
                    </>
                  ) : null}
                </>
              ) : null}

              <GridItem xs={12}>
                <FormText color="white" tag="span">
                  Type of Title:
                </FormText>
                <Input
                  onChange={(value) => {
                    value.preventDefault();
                    saveData("typeOfTitle", value.target.value);
                  }}
                  fullWidth
                  type="select"
                  style={{
                    borderWidth: 2,
                    borderColor: "#f00000",
                    backgroundColor: "white",
                    color: "grey",
                  }}
                  placeholder="Select an item..."
                >
                  <option value="">Select a Title Type</option>
                  <option>Freehold</option>
                  <option>Sectional Title</option>
                  <option>None</option>
                  <option>Share Block</option>
                </Input>
              </GridItem>

              <GridItem xs={12}>
                <FormText color="white" tag="span">
                  Notes:
                </FormText>
                <Input
                  onChange={(value) => {
                    value.preventDefault();
                    saveData("additionalNotes", value.target.value);
                  }}
                  fullWidth
                  type="text"
                  className={styles.input}
                  placeholder="notes"
                />
              </GridItem>
            </GridContainer>
          </GridItem>
        </CardBody>
      </Card>
    );
  };

  const renderSellerInfoCard = () => {
    return (
      <Card
        style={{
          backgroundColor: "#399ddb",
          width: "100%",
          height: "100%",
        }}
      >
        <CardHeader>
          <CardTitle tag="h4" style={{ color: "white" }}>
            Property Owner Details
          </CardTitle>
        </CardHeader>
        <CardBody>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <GridContainer spacing={1}>
              <GridItem xs={12}>
                <FormText color="white" tag="span">
                  Owner:
                </FormText>
                <Input
                  onChange={(value) => {
                    value.preventDefault();
                    saveUserData("ownername", value.target.value);
                  }}
                  fullWidth
                  type="text"
                  className={styles.input}
                  placeholder="Owner name"
                />
              </GridItem>

              <GridItem xs={12}>
                <FormText color="white" tag="span">
                  Seller Entity Name:
                </FormText>
                <Input
                  onChange={(value) => {
                    value.preventDefault();
                    saveUserData("entityName", value.target.value);
                  }}
                  fullWidth
                  type="text"
                  className={styles.input}
                  placeholder="Entity name"
                />
              </GridItem>

              <GridItem xs={12}>
                <FormText color="white" tag="span">
                  Seller Entity Number:
                </FormText>
                <Input
                  onChange={(value) => {
                    value.preventDefault();
                    saveUserData("entityNumber", value.target.value);
                  }}
                  fullWidth
                  type="text"
                  className={styles.input}
                  placeholder="Entity Number"
                />
              </GridItem>

              <GridItem xs={12}>
                <FormText color="white" tag="span">
                  Seller Postal Address:
                </FormText>

                <GoogleMapsAutoComplete
                  onChange={(value) => {
                    saveUserData("postalAddress", value);
                  }}
                  className={styles.input}
                  placeholder="Find Post address"
                />
              </GridItem>

              <GridItem xs={12}>
                <FormText color="white" tag="span">
                  Cell Number:
                </FormText>
                <Input
                  onChange={(value) => {
                    value.preventDefault();
                    saveUserData("cellTel", value.target.value);
                  }}
                  fullWidth
                  type="number"
                  className={styles.input}
                  placeholder="Phone number"
                />
              </GridItem>

              <GridItem xs={12}>
                <FormText color="white" tag="span">
                  Home Number:
                </FormText>
                <Input
                  onChange={(value) => {
                    value.preventDefault();
                    saveUserData("homeTel", value.target.value);
                  }}
                  fullWidth
                  type="number"
                  className={styles.input}
                  placeholder="Home number"
                />
              </GridItem>

              <GridItem xs={12}>
                <FormText color="white" tag="span">
                  Work Number:
                </FormText>
                <Input
                  onChange={(value) => {
                    value.preventDefault();
                    saveUserData("workTel", value.target.value);
                  }}
                  fullWidth
                  type="number"
                  className={styles.input}
                  placeholder="Work number"
                />
              </GridItem>

              <GridItem xs={12}>
                <FormText color="white" tag="span">
                  Fax:
                </FormText>
                <Input
                  onChange={(value) => {
                    value.preventDefault();
                    saveUserData("fax", value.target.value);
                  }}
                  fullWidth
                  type="number"
                  className={styles.input}
                  placeholder="Fax number"
                />
              </GridItem>

              <GridItem xs={12}>
                <FormText color="white" tag="span">
                  Email:
                </FormText>
                <Input
                  onChange={(value) => {
                    value.preventDefault();
                    saveUserData("email", value.target.value);
                  }}
                  fullWidth
                  type="email"
                  className={styles.input}
                  placeholder="Email"
                />
              </GridItem>

              <GridItem xs={12}>
                <Label
                  check
                  className={styles.radioText}
                  style={{ color: "white", marginTop: 20 }}
                >
                  Vat Vender:
                  <Input
                    type="checkbox"
                    className={styles.checkinput}
                    onChange={(value) => {
                      saveUserData("vatVendor", !state.seller.vatVendor);
                    }}
                  />
                </Label>
              </GridItem>

              {/* {state.seller.vatVendor ? (
                <GridItem xs={12}>
                  <FormText color="white" tag="span">
                    Vat Number:
                  </FormText>
                  <Input
                    onChange={(value) => {
                      value.preventDefault();
                      saveUserData("vatNumber", value.target.value);
                    }}
                    fullWidth
                    type="number"
                    className={styles.input}
                    placeholder="Vat Number"
                  />
                </GridItem>
              ) : null} */}
            </GridContainer>
          </GridItem>
        </CardBody>
      </Card>
    );
  };

  const renderMarketingInfoCard = () => {
    return (
      <Card
        style={{
          backgroundColor: "#399ddb",
          width: "100%",
          height: "100%",
        }}
      >
        <CardHeader>
          <CardTitle tag="h4" style={{ color: "white" }}>
            Marketing Details
          </CardTitle>
        </CardHeader>
        <CardBody>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <GridContainer spacing={1}>
              <GridItem xs={12}>
                <FormText color="white" tag="span">
                  Marketing Header:
                </FormText>
                <Input
                  onChange={(value) => {
                    value.preventDefault();
                    saveData("marketingHeading", value.target.value);
                  }}
                  fullWidth
                  type="text"
                  className={styles.input}
                  placeholder="Header"
                />
              </GridItem>

              <GridItem xs={12}>
                <FormText color="white" tag="span">
                  Description:
                </FormText>
                <Input
                  onChange={(value) => {
                    value.preventDefault();
                    saveData("description", value.target.value);
                  }}
                  fullWidth
                  type="textarea"
                  className={styles.descriptioninput}
                />
              </GridItem>
            </GridContainer>
          </GridItem>
        </CardBody>
      </Card>
    );
  };

  const renderMediaCaptureCard = () => {
    return (
      <Card
        style={{
          backgroundColor: "#399ddb",
          width: "100%",
          height: "100%",
        }}
      >
        <CardHeader>
          <CardTitle tag="h4" style={{ color: "white" }}>
            Media Details
          </CardTitle>
        </CardHeader>
        <CardBody>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <GridContainer spacing={1}>
              <GridItem xs={6}>
                <FormText color="white" tag="span">
                  Image Select:
                </FormText>
                <Input
                  onChange={onImageChange}
                  fullWidth
                  type="file"
                  multiple
                  accept="image/*"
                  className={styles.input}
                />
              </GridItem>
              <GridItem xs={6}>
                {image.map((imageSrc) => (
                  <img
                    src={URL.createObjectURL(imageSrc)}
                    alt="not fount"
                    width={"250px"}
                  />
                ))}
              </GridItem>

              <GridItem xs={6}>
                <FormText color="white" tag="span">
                  YouTube Video URL:
                </FormText>
                <Input
                  onChange={(value) => {
                    value.preventDefault();
                    isYouTubeVideo(value.target.value)
                      ? saveVideoData("Video0", value.target.value)
                      : alert(
                        "Please provide the YouTube videos embedded link"
                      );
                  }}
                  fullWidth
                  type="text"
                  className={styles.input}
                  placeholder="URL"
                />
              </GridItem>
              <GridItem xs={6}>
                {video ? (
                  <video width="750" height="500" controls>
                    <source src={video} type="video/*" />
                  </video>
                ) : null}
              </GridItem>
            </GridContainer>
          </GridItem>
        </CardBody>
      </Card>
    );
  };

  const renderPropertyDimisionsCard = () => {
    return (
      <Card
        style={{
          backgroundColor: "#399ddb",
          width: "100%",
          height: "100%",
        }}
      >
        <CardHeader>
          <CardTitle tag="h4" style={{ color: "white" }}>
            Property Dimensions Details
          </CardTitle>
        </CardHeader>
        <CardBody>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <GridContainer spacing={1}>
              <GridItem xs={12}>
                <FormText color="white" tag="span">
                  Gross lettable area:
                </FormText>
                <Input
                  onChange={(value) => {
                    value.preventDefault();
                    saveData("gla", value.target.value);
                  }}
                  fullWidth
                  type="number"
                  className={styles.input}
                  placeholder="gla size"
                />
              </GridItem>

              <GridItem xs={12}>
                <FormText color="white" tag="span">
                  Floor Size:
                </FormText>
                <Input
                  onChange={(value) => {
                    value.preventDefault();
                    saveData("floorSize", value.target.value);
                  }}
                  fullWidth
                  type="number"
                  className={styles.input}
                  placeholder="Size of Floor"
                />
              </GridItem>

              <GridItem xs={12}>
                <FormText color="white" tag="span">
                  Land Size:
                </FormText>
                <Input
                  onChange={(value) => {
                    value.preventDefault();
                    saveData("landSize", value.target.value);
                  }}
                  fullWidth
                  type="number"
                  className={styles.input}
                  placeholder="Size of Land"
                />
              </GridItem>

              <GridItem xs={12}>
                <FormText color="white" tag="span">
                  Office space Size:
                </FormText>
                <Input
                  onChange={(value) => {
                    value.preventDefault();
                    saveData("officeSize", value.target.value);
                  }}
                  fullWidth
                  type="number"
                  className={styles.input}
                  placeholder="Size of Office"
                />
              </GridItem>

              <GridItem xs={12}>
                <FormText color="white" tag="span">
                  Office space Price:
                </FormText>
                <Input
                  onChange={(value) => {
                    value.preventDefault();
                    saveData("officePrice", value.target.value);
                  }}
                  fullWidth
                  type="number"
                  className={styles.input}
                  placeholder="Price Per Meter"
                />
              </GridItem>

              <GridItem xs={12}>
                <FormText color="white" tag="span">
                  Retail Size:
                </FormText>
                <Input
                  onChange={(value) => {
                    value.preventDefault();
                    saveData("retailSize", value.target.value);
                  }}
                  fullWidth
                  type="number"
                  className={styles.input}
                  placeholder="Size of Retail"
                />
              </GridItem>

              <GridItem xs={12}>
                <FormText color="white" tag="span">
                  Factory Size:
                </FormText>
                <Input
                  onChange={(value) => {
                    value.preventDefault();
                    saveData("factorySize", value.target.value);
                  }}
                  fullWidth
                  type="number"
                  className={styles.input}
                  placeholder="Size of Factory"
                />
              </GridItem>

              <GridItem xs={12}>
                <FormText color="white" tag="span">
                  Yard Size:
                </FormText>
                <Input
                  onChange={(value) => {
                    value.preventDefault();
                    saveData("yardSize", value.target.value);
                  }}
                  fullWidth
                  type="number"
                  className={styles.input}
                  placeholder="Size of Yard"
                />
              </GridItem>

              <GridItem xs={12}>
                <FormText color="white" tag="span">
                  Building height:
                </FormText>
                <Input
                  onChange={(value) => {
                    value.preventDefault();
                    saveData("buildingHieght", value.target.value);
                  }}
                  fullWidth
                  type="number"
                  className={styles.input}
                  placeholder="Building Height"
                />
              </GridItem>
            </GridContainer>
          </GridItem>
        </CardBody>
      </Card>
    );
  };

  const renderBranchesOptions = () => {
    let cities = [<option value="">Select a Branch</option>];
    let dataKeys = Object.keys(offices);

    for (let index = 0; index < dataKeys.length; index++) {
      const city = dataKeys[index];

      cities.push(
        <option key={index} value={city}>
          {city}
        </option>
      );
    }
    return cities;
  };

  const renderModal = () => {
    return (
      <Modal
        isOpen={isOpen}
        toggle={() => setIsOpen(false)}
        centered={true}
        size="xl"
      >
        <ModalHeader>Create Listing</ModalHeader>
        <ModalBody>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <GridContainer spacing={1}>
              <GridItem lg={6}>{renderPropertyInfoCard()}</GridItem>

              <GridItem lg={6}>
                <GridItem lg={12}>{renderMarketingInfoCard()}</GridItem>

                <GridItem lg={12}>{renderSellerInfoCard()}</GridItem>
              </GridItem>

              <GridItem lg={12}>{renderPropertyDimisionsCard()}</GridItem>

              <GridItem lg={12}>{renderMediaCaptureCard()}</GridItem>
            </GridContainer>
          </GridItem>
        </ModalBody>
        <ModalFooter>
          <Button
            onClick={() => {
              let ListingData = {
                ...state,

                address: {
                  coords: state.address.coords
                    ? state.address.coords
                    : {
                      lat: 0.0,
                      lng: 0.0,
                    },
                  description: state.address.description
                    ? state.address.description
                    : " ",
                  suburb: state?.address?.description
                    ? state.address.description
                    : " ",
                  address: state?.address?.description
                    ? state?.address?.description
                    : " ",
                  streetNumber: state?.address?.streetNumber
                    ? state?.address?.streetNumber
                    : " ",
                  streetName: state?.address?.streetName
                    ? state?.address?.streetName
                    : " ",
                  unitNumber: state?.address?.unitNumber
                    ? state?.address?.unitNumber
                    : " ",
                  complexName: state?.address?.complexName
                    ? state?.address?.complexName
                    : " ",
                  floorNumber: state?.address?.floorNumber
                    ? state?.address?.floorNumber
                    : " ",
                  buildingName: state?.address?.buildingName
                    ? state?.address?.buildingName
                    : " ",
                },
              };

              // Check if email is valid
              if (re.test(ListingData.seller.email)) {
                // Check if phone number is valid
                if (phoneRegex.test(ListingData.seller.cellTel)) {
                  if (state.gla) {
                    // Check if images are provided
                    if (!image || image.length === 0) {
                      alert(
                        "Please upload at least one image before creating the listing."
                      );
                    } else {
                      if (ListingData.address.description) {
                        console.log(
                          `Listing data: ${JSON.stringify(ListingData)}`
                        );
                        dispatch(CreateListing(ListingData, image, video));
                      } else {
                        alert("Address is a required field.");
                      }
                    }
                  } else {
                    alert("Gross lettable area is a required field.");
                  }
                } else {
                  alert(language.proper_input_mobile);
                }
              } else {
                alert("Please provide a proper email");
              }
            }}
          >
            Create Listing
          </Button>

          <Button
            style={{
              backgroundColor: "#ff000f",
              height: 45,
            }}
          >
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    );
  };

  //functions
  function onImageChange(e) {
    setImage([...e.target.files]);
  }
  const saveData = (location, data) => {
    setstate({
      ...state,
      [location]: data,
    });
  };

  const saveAddressData = (location, data) => {
    setstate({
      ...state,
      address: { ...state?.address, [location]: data },
    });
  };

  const saveVideoData = (location, data) => {
    setstate({
      ...state,
      video: { ...state?.video, [location]: data },
    });
  };

  const saveUserData = (location, data) => {
    setstate({
      ...state,
      seller: {
        ...state.seller,
        [location]: data,
      },
    });
  };

  return (
    <>
      <AddBoxRounded
        onClick={toggleTwo}
        style={{
          color: "#ff000f",
          alignItems: "right",
          width: 50,
          height: 50,
          cursor: "pointer",
        }}
      />
      {renderModal()}
    </>
  );
}
